import * as React from 'react'

import { Box, Divider, Text, Title } from '@factorialco/deprecated-design-system'

import TextArea from 'modules/core/components/TextArea'
import TextField from 'modules/core/components/TextField'
import i18n from 'modules/core/lib/i18n'

import DropItem, { UploadFile } from 'modules/expenses/components/common/DropItem'
import DropZoneBox from 'modules/expenses/components/common/DropZone'
import OwnerField from 'modules/expenses/components/expenses/Form/OwnerField'
import { usePerDiemWizard } from 'modules/expenses/components/expenses/New/PerDiemWizard/form/context'

const fileToUploadFile = (file: File): UploadFile => ({
  id: null,
  name: file.name,
  size: String(file.size),
  type: file.type,
  preview: URL.createObjectURL(file),
})

const AdditionalInformation = () => {
  const { data, updateData } = usePerDiemWizard()

  const handleDescriptionChange = (value: string) => {
    updateData({ description: value || undefined })
  }

  const handleInternalReferenceChange = (value: string) => {
    updateData({ internalReference: value || undefined })
  }

  const handleFileDrop = (droppedFiles: File[]) => {
    updateData({ files: [...data.files, ...droppedFiles] })
  }

  const handleRemoveFile = (fileToRemove: UploadFile) => {
    const updatedFiles = data.files.filter(
      (file) => !(file.name === fileToRemove.name && String(file.size) === fileToRemove.size)
    )
    updateData({ files: updatedFiles })
  }

  const uploadFiles: UploadFile[] = data.files.map(fileToUploadFile)

  return (
    <Box flexDirection="column" gap="s16">
      <Box flexDirection="column" gap="s4">
        <Title
          variant="400"
          title={i18n.t('expenses_v2.forms.new_form.blocks.additional_information')}
        />
        <Text.Normal size="200" color="grey800">
          {i18n.t('expenses_v2.forms.new_form.blocks.additional_information_subtitle')}
        </Text.Normal>
      </Box>

      <Box flexDirection="column" gap="s4">
        <OwnerField
          employeeId={data.requesterId}
          onEmployeeIdSelected={(employeeId) => updateData({ requesterId: employeeId })}
          showEmployeeLegalEntity={false}
        />
      </Box>

      <Box flexDirection="column" gap="s4">
        <TextArea
          label={i18n.t('expenses_v2.forms.fields.description.label')}
          placeholder={i18n.t('expenses_v2.forms.fields.description.placeholder')}
          value={data.description || ''}
          onChange={handleDescriptionChange}
        />
      </Box>

      <Box flexDirection="column" gap="s4">
        <TextField
          label={i18n.t('expenses_v2.forms.fields.reference.label')}
          placeholder={i18n.t('expenses_v2.forms.fields.reference.placeholder')}
          value={data.internalReference || ''}
          onChange={handleInternalReferenceChange}
        />
      </Box>

      <Box flexDirection="column" gap="s8">
        <DropZoneBox
          onDrop={handleFileDrop}
          title={i18n.t('expenses_v2.forms.fields.dropzone.title')}
          description={i18n.t('expenses_v2.forms.fields.dropzone.description')}
          multiple
        />
        {uploadFiles.map((file) => (
          <DropItem
            key={file.name + file.size}
            file={file}
            removable
            onRemove={handleRemoveFile}
            downloadable={false}
          />
        ))}
      </Box>

      <Box paddingTop="s8" paddingBottom="s8">
        <Divider vertical={false} />
      </Box>
    </Box>
  )
}

export default AdditionalInformation
